<template>
    <div>
        <v-card class="ma-3 pa-5" v-if="activeStations && activeStations.length > 1">
            <v-row>
                <p class="text-subtitle-2 pa-3">This is intended to display other stations that have been merged with
                    the selected station. The merging may occur due to a module failure or the installation of a new
                    station. Although the physical station is replaced, data continuity is maintained by linking the
                    stations together.</p>
            </v-row>
            <v-row justify="space-between" class="pa-3" v-for="station in withoutActiveStation"
                   :key="`group_${station.id}`">
                <h3>{{ station.name }}</h3>
                <v-spacer/>

                <v-btn @click="navigateToStation(station)" color="primary" small>Navigate
                    <v-icon
                        right
                        dark
                    >
                        mdi-arrow-right
                    </v-icon>
                </v-btn>
            </v-row>
        </v-card>
    </div>
</template>

<script>
import { mapState } from 'vuex';

export default {
    name: 'StationGroupInformation',
    data() {
        return {};
    },
    computed: {
        ...mapState('probe', ['activeStations', 'activeProbe']),
        withoutActiveStation() {
            return this.activeStations.filter(station => station.id !== this.activeProbe.id);
        },
    },
    methods: {
        navigateToStation(station) {
            const route = this.$router.resolve({ name: 'station-view', params: { id: station.id } });
            window.location = route.href;
        },
    },
};
</script>

<style scoped></style>
